const env = process.env.REACT_APP_ENV || 'development';

export const config = {
  env,
  gatewayUrl: process.env.REACT_APP_GATEWAY_URL || 'http://localhost:4000',
  appName: process.env.REACT_APP_APP_NAME || 'TPC Admin',
  isProduction: env === 'production',
  isUAT: env === 'uat',
  isDevelopment: env === 'development',
};
